<template>
  <div>
    <courseRecordDetails
      :courseObject="dataObject.courseDetail ? dataObject.courseDetail[0] : courseDetail"
      :examMode="examMode"
      :exportMode="exportMode"
      :overviewMode="overviewMode"
      @returnDataPayload="returnDataPayload"
      @returnExamMode="returnExamMode"
      @returnExportMode="returnExportMode"
      @returnOverviewMode="returnOverviewMode"
    />

    <div v-if="loading" style="margin-top: 3rem;">
      <LoadingMDL />
    </div>
    <div v-else style="margin-top: 2rem;">
      <examination
        v-if="examMode && !exportMode"
        :testData="testDataTable"
        :courseSection="sectionExam"
        :courseDetailData="payload"
        @returnUpdateQuiz="returnUpdateQuiz"
      />

      <!-- <userInCourse
        v-if="!examMode && !exportMode"
        :userInCourse="dataObject"
      /> -->
      <nameList v-if="!examMode && !exportMode" :nameListData="dataObject" />
    </div>
  </div>
</template>

<script>
import courseRecordDetails from './courseRecordDetails';
import userInCourse from './userInCourse';
import progressCourseOverview from './progressCourseOverview';
import nameList from './nameList';
import examination from '../examination/examination';
import LoadingMDL from '../../../loading/LoadingMDL';
import {mapGetters} from 'vuex';
import XLSX from 'xlsx';
import '../../../../assets/scss/_chineseStyle.scss';
import '../../../../assets/scss/_chineseIcon.scss';
import '../../../../assets/scss/_chineseModalCustom.scss';

export default {
  name: 'CourseRecordOverviewDetail',
  components: {
    courseRecordDetails,
    userInCourse,
    progressCourseOverview,
    nameList,
    examination,
    LoadingMDL,
  },
  data() {
    return {
      courseId: '',
      courseDetail: {},
      option: [],
      sectionObject: {},
      dataObject: {},
      nameListObject: [],
      isChange: false,
      returnDataBack: {},
      userInCourseData: {},
      examMode: false,
      exportMode: false,
      overviewMode: true,
      testDataTable: [],
      dataExport: [],
      dataExportChinese2: [],
      payload: [],
      loading: true,
      sectionExam: 0,
      v3Export: [],
    };
  },
  computed: {
    ...mapGetters({
      getCourseDetail: 'courses/getCourseDetail',
      getDataExport: 'courses/getDataExport',
      getQuiz: 'courses/getQuiz',
      getDataExportChinese2: 'courses/getDataExportChinese2',
      v3TeacherCourseDetails: 'v3-data/v3TeacherCourseDetails',
      v3TeacherExport: 'v3-data/v3TeacherExport',
      v3TeacherLessonLock: 'v3-data/v3TeacherLessonLock',
    }),
  },
  watch: {
    v3TeacherLessonLock(value) {
      console.log('v3TeacherLessonLock', value);
      this.testDataTable = value;
      this.loading = false;
    },
    v3TeacherExport(value) {
      this.v3Export = value;
      this.v3DynamicExport();

      //loading off
      this.loading = false;
    },
    v3TeacherCourseDetails(value) {
      console.log('v3TeacherCourseDetails v3TeacherCourseDetails', value);
      this.dataObject = value;
      this.sectionExam = value.courseDetail[0].code;
      this.loading = false;
    },
    getDataExport(val) {
      if (val && this.nameCourse == 'Chinese 1') {
        console.log('export course:', this.nameCourse);
        this.dataExport = val;
        console.log('watch setDataExport', this.dataExport);
        this.setDataExport();
      } else {
        console.log('export course:', this.nameCourse);
        this.dataExport = val;
        console.log('watch setDataExportPBLS', this.dataExport);
        this.setDataExportPBLS();
      }
    },
    getCourseDetail(value) {
      //อันเก่า ไม่ใช้เเล้ว
      console.log('getCourseDetail getCourseDetail getCourseDetail', value);

      this.dataObject = value;
      this.sectionExam = value.courseDetail[0].code;
      this.loading = false;
    },

    getQuiz(value) {
      this.testDataTable = {};
      this.testDataTable = value;
    },
    getDataExportChinese2: function (responseData) {
      if (responseData) {
        // console.log(responseData);
        this.dataExportChinese2 = responseData;
        this.setDataExportChinese2();
      }
    },
  },
  created() {
    this.$store.commit('language/setChangingSidebar', true);
    if (
      this.$store.getters['courses/getCourseObjectParams'] !== undefined &&
      this.$store.getters['courses/getCourseObjectParams'] !== '' &&
      this.$store.getters['courses/getCourseObjectParams'].length !== 0
    ) {
      this.courseDetail = this.$store.getters['courses/getCourseObjectParams'];
      
      // Update the instructor sections in Vuex to match the opened course!
      if (this.courseDetail && this.courseDetail.section) {
        this.$store.commit("necessary/setInstructorSection", this.courseDetail.section);
      }

      console.log(
        'this.courseDetail this.courseDetail this.courseDetail0',
        this.courseDetail
      );

      this.onLoadPage();
    } else {
      this.$router.push('/course-management/courses-overview');
    }
  },
  methods: {
    onLoadPage() {
      let CurrentCourseDetail = this.SemesterCalculation();
      let activeSection = this.courseDetail.section && this.courseDetail.section[0] ? this.courseDetail.section[0].code : '';
      
      const instructorSections = this.$store.getters["necessary/getInstructorSection"];
      if (instructorSections && instructorSections.length > 0) {
        const hasTesting = instructorSections.some((item) => item.code == "testing");
        if (hasTesting) {
          activeSection = "testing";
        } else {
          const sorted = [...instructorSections].sort((a, b) => {
            const numA = parseInt(a.code, 10);
            const numB = parseInt(b.code, 10);
            if (isNaN(numA) && isNaN(numB)) {
              return String(a.code).localeCompare(String(b.code));
            }
            if (isNaN(numA)) return 1;
            if (isNaN(numB)) return -1;
            return numA - numB;
          });
          activeSection = sorted[0].code;
        }
      }
      if (this.returnDataBack && this.returnDataBack.section) {
        activeSection = this.returnDataBack.section;
      }

      this.sectionExam = activeSection;

      this.payload = {
        courseId: this.courseDetail.courseId,
        academicYear: CurrentCourseDetail.academicYear,
        semester: CurrentCourseDetail.semester,
        section: activeSection,
      };

      if (this.examMode) {
        console.log('trigger exmamode');
        this.$store.dispatch('v3-data/v3TeacherLessonLock', this.payload);
        // this.$store.dispatch("courses/fetchQuiz", this.payload);
      } else {
        console.log('On loading when come to this page', this.payload);
        // this.$store.dispatch("courses/fetchCourseDetail", this.payload);
        this.$store.dispatch('v3-data/v3TeacherCourseDetails', this.payload);
      }
    },
    SemesterCalculation() {
      let store = {};
      let date = new Date();
      let semester = 0;
      if (date.getMonth() < 5) {
        semester = 2;
      } else if (date.getMonth() >= 5 && date.getMonth() <= 7) {
        semester = 3;
      } else if (date.getMonth() > 7 && date.getMonth() < 11) {
        semester = 1;
      }
      let academicYearTmp =
        semester == 3 || semester == 2
          ? date.getFullYear() - 1 + 543
          : date.getFullYear() + 543;
      return (store = {
        academicYear: academicYearTmp,
        semester: semester,
      });
    },
    returnDataPayload(data) {
      this.loading = true;
      this.sectionExam = data.section;
      this.returnDataBack = data;
      this.returnDataBack.courseId = this.courseDetail.courseId;
      let newPayload = {
        courseId: this.courseDetail.courseId,
        academicYear: data.academicYear,
        semester: data.semester,
        section: data.section,
      };

      console.log('returnDataPayload', newPayload);

      if (this.examMode) {
        this.$store.dispatch('v3-data/v3TeacherLessonLock', newPayload);
        // this.$store.dispatch("courses/fetchQuiz", newPayload);
      } else if (this.overviewMode) {
        console.log('xxxxxxxxxxxxxxxxxxxxxxxxxxxxx', this.overviewMode);
        this.$store.dispatch('v3-data/v3TeacherCourseDetails', newPayload);
        // this.$store.dispatch("courses/fetchCourseDetail", newPayload);
      } else if (this.exportMode) {
        //for export
        let courseName = this.$store.getters['courses/getCourseObjectParams'];
        console.log('xxxxxxx', courseName);
        this.nameCourse = courseName.courseName;
        console.log('trigger export');
        // trigger true
        this.loading = true;

        this.$store.dispatch('v3-data/v3TeacherExport', newPayload);

        // if (courseName.courseName == "Chinese 1") { //chn1
        //   console.log('chinese 1');
        //   let body = {
        //     courseId: this.returnDataBack.courseId,
        //     section: this.returnDataBack.section,
        //   };
        //   console.log('send data:',body);
        //   this.$store.dispatch("courses/fetchDataExport", body);

        // } else if(courseName.courseName == "Pediatric Basic Life Support"){
        //   console.log('Pediatric Basic Life Support');
        //   let body = {
        //     courseId: this.returnDataBack.courseId,
        //     section: this.returnDataBack.section,
        //   };
        //   console.log('send data:',body);
        //   this.$store.dispatch("courses/fetchDataExport", body);

        // } else {
        //   console.log('CHN2');
        //   let body = {
        //     code: this.returnDataBack.courseId,
        //     section: this.returnDataBack.section,
        //   };
        //   this.$store.dispatch("courses/fetchDataExportChinese2", body);

        // }
      }
    },
    returnExamMode() {
      this.exportMode = false;
      this.overviewMode = false;
      this.examMode = !this.examMode;
      if (this.examMode) {
        this.onLoadPage();
      }
    },
    returnExportMode() {
      this.examMode = false;
      this.overviewMode = false;
      this.exportMode = !this.exportMode;
      if (this.exportMode) {
        this.onLoadPage();
      }
    },
    returnOverviewMode() {
      this.examMode = false;
      this.exportMode = false;
      this.overviewMode = !this.overviewMode;
      if (this.overviewMode) {
        const instructorSections = this.$store.getters["necessary/getInstructorSection"];
        const isExistTesting = instructorSections && instructorSections.some((item) => item.code == "testing");
        if (isExistTesting) {
          this.returnDataBack.section = "testing";
        } else if (instructorSections && instructorSections.length > 0) {
          const sorted = [...instructorSections].sort((a, b) => {
            const numA = parseInt(a.code, 10);
            const numB = parseInt(b.code, 10);
            if (isNaN(numA) && isNaN(numB)) {
              return String(a.code).localeCompare(String(b.code));
            }
            if (isNaN(numA)) return 1;
            if (isNaN(numB)) return -1;
            return numA - numB;
          });
          this.returnDataBack.section = sorted[0].code;
        }
        this.onLoadPage();
      }
    },
    returnUpdateQuiz(data) {
      if (data) {
        console.log('lock test trigger returnUpdateQuiz');
        console.log(data);
        this.$store.dispatch('v3-data/v3TeacherLessonLockUpdate', data);
        // this.$store.dispatch("courses/updateQuizStatus", data);
      }
    },

    onExport(header) {
      var aoa = header;
      const dataWS = XLSX.utils.aoa_to_sheet(aoa);
      dataWS['!merges'] = [
        // Set the cell merge of A1-C1
        {s: {r: 0, c: 1}, e: {r: 0, c: 2}}, // Fname
        {s: {r: 0, c: 3}, e: {r: 0, c: 4}}, // lname
        {s: {r: 0, c: 0}, e: {r: 2, c: 0}}, // Student ID
        {s: {r: 0, c: 5}, e: {r: 2, c: 5}}, // Section
        {s: {r: 0, c: 6}, e: {r: 0, c: 45}}, //allProgress

        {s: {r: 1, c: 1}, e: {r: 2, c: 1}}, //fname-th
        {s: {r: 1, c: 2}, e: {r: 2, c: 2}}, //fname-en
        {s: {r: 1, c: 3}, e: {r: 2, c: 3}}, //lname-th
        {s: {r: 1, c: 4}, e: {r: 2, c: 4}}, //lname-en
        {s: {r: 1, c: 6}, e: {r: 2, c: 6}}, //pre-test
        {s: {r: 1, c: 7}, e: {r: 1, c: 10}}, //ch1
        {s: {r: 1, c: 11}, e: {r: 1, c: 14}}, //ch2
        {s: {r: 1, c: 15}, e: {r: 1, c: 18}}, //ch3
        {s: {r: 1, c: 19}, e: {r: 1, c: 22}}, //ch4
        {s: {r: 1, c: 23}, e: {r: 1, c: 26}}, //ch5
        {s: {r: 1, c: 27}, e: {r: 1, c: 30}}, //ch6
        {s: {r: 1, c: 31}, e: {r: 1, c: 34}}, //ch7
        {s: {r: 1, c: 35}, e: {r: 1, c: 38}}, //ch8
        {s: {r: 1, c: 39}, e: {r: 1, c: 42}}, //ch9
        {s: {r: 1, c: 43}, e: {r: 1, c: 46}}, //ch10
        {s: {r: 1, c: 47}, e: {r: 2, c: 47}}, //post-test
      ];
      //Control cell width
      dataWS['!cols'] = [
        {wpx: 70},
        {wpx: 100},
        {wpx: 100},
        {wpx: 100},
        {wpx: 100},
        {wpx: 100},
        {wpx: 100},
      ];
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, dataWS);
      XLSX.writeFile(
        wb,
        'Chinese1_Section' + this.returnDataBack.section + '.xlsx'
      );
    },
    onExportPBLS(header) {
      console.log('onExportPBLS');
      var aoa = header;
      const dataWS = XLSX.utils.aoa_to_sheet(aoa);
      dataWS['!merges'] = [
        // Set the cell merge of A1-C1
        {s: {r: 0, c: 1}, e: {r: 0, c: 2}}, // Fname
        {s: {r: 0, c: 3}, e: {r: 0, c: 4}}, // lname
        {s: {r: 0, c: 0}, e: {r: 2, c: 0}}, // Student ID
        {s: {r: 0, c: 5}, e: {r: 2, c: 5}}, // Section
        {s: {r: 0, c: 6}, e: {r: 0, c: 45}}, //allProgress

        {s: {r: 1, c: 1}, e: {r: 2, c: 1}}, //fname-th
        {s: {r: 1, c: 2}, e: {r: 2, c: 2}}, //fname-en
        {s: {r: 1, c: 3}, e: {r: 2, c: 3}}, //lname-th
        {s: {r: 1, c: 4}, e: {r: 2, c: 4}}, //lname-en
        {s: {r: 1, c: 6}, e: {r: 2, c: 6}}, //pre-test
        {s: {r: 1, c: 7}, e: {r: 1, c: 10}}, //ch1
        {s: {r: 1, c: 11}, e: {r: 1, c: 14}}, //ch2
        {s: {r: 1, c: 15}, e: {r: 1, c: 18}}, //ch3
        {s: {r: 1, c: 19}, e: {r: 1, c: 22}}, //ch4
        {s: {r: 1, c: 23}, e: {r: 1, c: 26}}, //ch5
        {s: {r: 1, c: 27}, e: {r: 1, c: 30}}, //ch6
        {s: {r: 1, c: 31}, e: {r: 1, c: 34}}, //ch7
        {s: {r: 1, c: 35}, e: {r: 1, c: 38}}, //ch8
        {s: {r: 1, c: 39}, e: {r: 1, c: 42}}, //ch9
        {s: {r: 1, c: 43}, e: {r: 1, c: 46}}, //ch10
        {s: {r: 1, c: 47}, e: {r: 2, c: 47}}, //post-test
      ];
      //Control cell width
      dataWS['!cols'] = [
        {wpx: 70},
        {wpx: 100},
        {wpx: 100},
        {wpx: 100},
        {wpx: 100},
        {wpx: 100},
        {wpx: 100},
      ];
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, dataWS);
      XLSX.writeFile(
        wb,
        'PBLS_Section' + this.returnDataBack.section + '.xlsx'
      );
    },
    onExportChinese2(header) {
      var aoa = header;
      const dataWS = XLSX.utils.aoa_to_sheet(aoa);
      dataWS['!merges'] = [
        // Set the cell merge of A1-C1
        {s: {r: 0, c: 0}, e: {r: 1, c: 0}}, // Student ID
        {s: {r: 0, c: 1}, e: {r: 1, c: 1}}, //fname
        {s: {r: 0, c: 2}, e: {r: 1, c: 2}}, //lname
        {s: {r: 0, c: 3}, e: {r: 1, c: 3}}, //section
        {s: {r: 0, c: 4}, e: {r: 1, c: 4}}, //pre test
        {s: {r: 0, c: 5}, e: {r: 0, c: 7}}, //Lesson 1
        {s: {r: 0, c: 8}, e: {r: 0, c: 10}}, //Lesson 2
        {s: {r: 0, c: 11}, e: {r: 0, c: 13}}, //Lesson 3
        {s: {r: 0, c: 14}, e: {r: 0, c: 16}}, //Lesson 4
        {s: {r: 0, c: 17}, e: {r: 0, c: 19}}, //Lesson 5
        {s: {r: 0, c: 20}, e: {r: 0, c: 22}}, //Lesson 6
        {s: {r: 0, c: 23}, e: {r: 0, c: 25}}, //Lesson 7
        {s: {r: 0, c: 26}, e: {r: 0, c: 28}}, //Lesson 8
        {s: {r: 0, c: 29}, e: {r: 0, c: 31}}, //Lesson 9
        {s: {r: 0, c: 32}, e: {r: 0, c: 34}}, //Lesson 10
        {s: {r: 0, c: 35}, e: {r: 1, c: 35}}, //post test
      ];
      //Control cell width
      dataWS['!cols'] = [
        {wpx: 70},
        {wpx: 100},
        {wpx: 100},
        {wpx: 100},
        {wpx: 100},
        {wpx: 100},
        {wpx: 100},
        {wpx: 100},
        {wpx: 100},
        {wpx: 100},
        {wpx: 100},
        {wpx: 100},
        {wpx: 100},
        {wpx: 100},
        {wpx: 100},
        {wpx: 100},
        {wpx: 100},
        {wpx: 100},
        {wpx: 100},
        {wpx: 100},
        {wpx: 100},
        {wpx: 100},
        {wpx: 100},
        {wpx: 100},
        {wpx: 100},
        {wpx: 100},
        {wpx: 100},
        {wpx: 100},
        {wpx: 100},
        {wpx: 100},
        {wpx: 100},
        {wpx: 100},
        {wpx: 100},
        {wpx: 100},
        {wpx: 100},
        {wpx: 100},
        {wpx: 100},
      ];
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, dataWS);
      XLSX.writeFile(
        wb,
        '_MDL_Course_Export_' + this.returnDataBack.section + '.xlsx'
      );
      this.$store.commit('courses/setExportLoading', false);
    },
    setDataExportChinese2() {
      if (this.dataExportChinese2.length > 0) {
        let mockHeader = [
          ['Student ID', 'Firstname', 'Lastname', 'Section'],
          [null, null, null, null, null],
        ];
        this.dataExportChinese2.forEach((element, index) => {
          //set header all progress
          if (index == 0) {
            let countProgress = 0;
            element.mainProgress.lesson.forEach((chapter, index) => {
              if (index == 0) {
                if (chapter.type == 'pretest') {
                  mockHeader[0].push('Pre Test');
                  countProgress++;
                }
              } else {
                if (chapter.type == 'chapter') {
                  mockHeader[0].push(chapter.type + index, null, null);
                  mockHeader[1].push(
                    'Assignment Score',
                    'Test Score',
                    'Progress (100%)'
                  );
                } else if (chapter.type == 'posttest') {
                  mockHeader[0].push('Post Test');
                  mockHeader[1].push(null);
                }
              }
            });
          }
        });
        this.dataExportChinese2.forEach((element, index) => {
          let student = [];
          student.push(
            element.userDetails.codeId ? element.userDetails.codeId : '-'
          ); //StudentID

          student.push(
            element.userDetails.firstname.length != 0
              ? element.userDetails.firstname[0].val
              : '-'
          ); // First Name

          student.push(
            element.userDetails.lastname.length != 0
              ? element.userDetails.lastname[0].val
              : '-'
          ); // Last Name

          student.push(
            element.mainProgress.section == null
              ? '-'
              : element.mainProgress.section
          ); // Section

          student.push(
            element.mainProgress.lesson[0].score == undefined
              ? 0
              : element.mainProgress.lesson[0].score
          ); // Pre Test Scores

          // set data all progress
          element.subProgress.forEach((chapter, index) => {
            let assignmentScore = 0;
            let testScore = 0;
            for (let i = 0; i < chapter.topic.length; i++) {
              if (chapter.topic[i].type == 'test') {
                testScore = chapter.topic[i].score;
              } else if (chapter.topic[i].type == 'assignment') {
                assignmentScore = chapter.topic[i].score;
              }
            }
            student.push(assignmentScore);
            student.push(testScore);
            student.push(
              element.mainProgress.lesson[index + 1].progress.toFixed(2)
            );
          });

          student.push(
            element.mainProgress.lesson[0].score == undefined
              ? 0
              : element.mainProgress.lesson[11].score
          ); // Post Test Scores

          mockHeader.push(student);
        });
        this.onExportChinese2(mockHeader);
      }
    },
    setDataExport() {
      console.log('setDataExport', this.dataExport);
      if (this.dataExport.length > 0) {
        let mockHeader = [
          ['Student ID', 'Firstname', null, 'Lastname', null, 'Section'],
          [null, 'EN', 'TH', 'EN', 'TH', null],
          [null, null, null, null, null, null],
        ];

        this.dataExport.forEach((element, index) => {
          //set header all progress
          if (index == 0) {
            let countProgress = 0;
            element.progress.template.forEach((chapter, index) => {
              if (index == 0) {
                if (chapter.type == 'pretest')
                  mockHeader[0].push('All Progress');
                mockHeader[1].push('Pre Test');
                mockHeader[2].push(null);
                countProgress++;
              } else {
                if (chapter.type == 'chapter') {
                  mockHeader[0].push(null, null, null, null);
                  mockHeader[1].push(chapter.type + index, null, null, null);
                  mockHeader[2].push(
                    'Progress (100%)',
                    'Use times (Minutes)',
                    'Assignment',
                    'Test'
                  );
                } else if (chapter.type == 'posttest') {
                  mockHeader[0].push(null);
                  mockHeader[1].push('Post Test');
                  mockHeader[2].push(null);
                }
              }
            });
          }
        });
        this.dataExport.forEach((element, index) => {
          let student = [];

          student.push(element.user.id ? element.user.id : '-'); //StudentID

          if (element.user.firstname.length <= 0) {
            student.push('-'); //fname EN
            student.push('-'); //fname TH
          } else {
            student.push(this.$helpers.translate(element.user.firstname, 'en'));
            student.push(this.$helpers.translate(element.user.firstname, 'th'));
          }

          if (element.user.lastname.length <= 0) {
            student.push('-'); //fname EN
            student.push('-'); //fname TH
          } else {
            student.push(this.$helpers.translate(element.user.lastname, 'en'));
            student.push(this.$helpers.translate(element.user.lastname, 'th'));
          }

          student.push(
            element.section
              ? element.section
              : this.courseDetail.section[0].code
          ); //section

          //   // set data all progress
          element.progress.template.forEach((chapter, index) => {
            if (index == 0) {
              student.push(chapter.quizScore);
            } else {
              if (chapter.type == 'posttest') {
                student.push(chapter.quizScore);
              } else {
                student.push(chapter.progress); //progress
                student.push(chapter.usetime); //user time

                chapter.template.forEach((item, index) => {
                  if (item.type == 'assignment') {
                    student.push(item.quizScore);
                  }
                });
                chapter.template.forEach((item, index) => {
                  if (item.type == 'test') {
                    student.push(item.quizScore);
                  }
                });
              }
            }
          });
          mockHeader.push(student);
        });

        this.onExport(mockHeader);
      } else {
        alert('No Data');
      }
    },
    setDataExportPBLS() {
      console.log('setDataExportPBLS', this.dataExport);
      if (this.dataExport.length > 0) {
        let mockHeader = [
          ['Student ID', 'Firstname', null, 'Lastname', null, 'Section'],
          [null, 'EN', 'TH', 'EN', 'TH', null],
          [null, null, null, null, null, null],
        ];

        this.dataExport.forEach((element, index) => {
          //set header all progress
          if (index == 0) {
            let countProgress = 0;
            element.progress.template.forEach((chapter, index) => {
              if (index == 0) {
                //if (chapter.type == "topic"){
                mockHeader[0].push('All Progress');
                mockHeader[1].push('Pre Test');
                mockHeader[2].push(null);
                countProgress++;
                //}
              } else {
                if (chapter.type == 'topic') {
                  mockHeader[0].push(null, null, null, null);
                  mockHeader[1].push(chapter.type + index, null, null, null);
                  mockHeader[2].push(
                    'Progress (100%)',
                    'Use times (Minutes)',
                    'Assignment',
                    'Test'
                  );
                } else if (chapter.type == 'posttest') {
                  mockHeader[0].push(null);
                  mockHeader[1].push('Post Test');
                  mockHeader[2].push(null);
                }
              }
            });
          }
        });

        this.dataExport.forEach((element, index) => {
          let student = [];

          student.push(element.user.id ? element.user.id : '-'); //StudentID

          if (element.user.firstname.length <= 0) {
            student.push('-'); //fname EN
            student.push('-'); //fname TH
          } else {
            student.push(this.$helpers.translate(element.user.firstname, 'en'));
            student.push(this.$helpers.translate(element.user.firstname, 'th'));
          }

          if (element.user.lastname.length <= 0) {
            student.push('-'); //fname EN
            student.push('-'); //fname TH
          } else {
            student.push(this.$helpers.translate(element.user.lastname, 'en'));
            student.push(this.$helpers.translate(element.user.lastname, 'th'));
          }

          student.push(
            element.section
              ? element.section
              : this.courseDetail.section[0].code
          ); //section

          //   // set data all progress
          element.progress.template.forEach((chapter, index) => {
            if (index == 0) {
              student.push(chapter.quizScore);
            } else {
              if (chapter.type == 'posttest') {
                student.push(chapter.quizScore);
              } else {
                student.push(chapter.progress); //progress
                student.push(chapter.usetime); //user time

                chapter.template.forEach((item, index) => {
                  if (item.type == 'topic') {
                    student.push(item.quizScore);
                  }
                });
                chapter.template.forEach((item, index) => {
                  if (item.type == 'test') {
                    student.push(item.quizScore);
                  }
                });
              }
            }
          });
          mockHeader.push(student);
        });
        console.log('mockHeader', mockHeader);
        this.onExportPBLS(mockHeader);
      } else {
        alert('No Data');
      }
    },

    v3DynamicExport() {
      if (this.v3Export.length > 0) {
        let mockHeader = [
          ['Student ID', 'Firstname', 'Lastname', 'Section'],
          [null, null, null, null, null],
        ];
        this.v3Export.forEach((element, index) => {
          //set header all progress
          if (index == 0) {
            let countProgress = 0;
            element.progress.forEach((chapter, index) => {
              if (index == 0) {
                if (chapter.type == 'pretest') {
                  mockHeader[0].push('Pre Test');
                  countProgress++;
                }
              } else {
                if (chapter.type == 'chapter') {
                  mockHeader[0].push(chapter.type + index, null, null);
                  mockHeader[1].push(
                    'Assignment Score',
                    'Test Score',
                    'Progress (100%)'
                  );
                } else if (chapter.type == 'posttest') {
                  mockHeader[0].push('Post Test');
                  mockHeader[1].push(null);
                }
              }
            });
          }
        });
        this.v3Export.forEach((element, index) => {
          let student = [];
          student.push(element.codeId ? element.codeId : '-'); //StudentID
          student.push(
            element.firstname.length != 0 ? element.firstname[0].val : '-'
          ); // First Name
          student.push(
            element.lastname.length != 0 ? element.lastname[0].val : '-'
          ); // Last Name
          student.push(element.section == null ? '-' : element.section); // Section

          student.push(
            element.progress[0].score == undefined
              ? 0
              : element.progress[0].score
          ); // Pre Test Scores

          // set data all progress
          element.progress.forEach((chapter, index) => {
            let assignmentScore = 0;
            let testScore = 0;
            if (chapter.type == 'pretest' || chapter.type == 'posttest') {
              // do nothing
            } else {
              assignmentScore = chapter.assignment;
              testScore = chapter.test;
              student.push(assignmentScore);
              student.push(testScore);
              student.push(chapter.progress.toFixed(2));
            }
          });

          student.push(
            element.progress[0].score == undefined
              ? 0
              : element.progress[11].score
          ); // Post Test Scores

          mockHeader.push(student);
        });
        console.log('mockHeader', mockHeader);

        this.onExportChinese2(mockHeader);
      }
    },
  },
};
</script>
